import { SvgIcon, type SvgIconProps } from '@mui/material';

export const SideDoorIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 32 32"
    fill="none"
    stroke="none"
    className="feather-icons"
    {...props}
  >
    <path
      d="M29.6686 14.7307C29.5877 14.7307 29.5101 14.7631 29.4529 14.8209C29.3957 14.8786 29.3636 14.9569 29.3636 15.0385V23.1902C29.3607 23.2323 29.3665 23.2745 29.3805 23.3143C29.3945 23.354 29.4164 23.3905 29.445 23.4213C29.4735 23.4521 29.508 23.4767 29.5464 23.4935C29.5847 23.5103 29.6261 23.519 29.6679 23.519C29.7097 23.519 29.751 23.5103 29.7894 23.4935C29.8277 23.4767 29.8622 23.4521 29.8908 23.4213C29.9193 23.3905 29.9413 23.354 29.9553 23.3143C29.9693 23.2745 29.975 23.2323 29.9722 23.1902V15.0385C29.9722 14.9571 29.9402 14.8791 29.8833 14.8214C29.8264 14.7637 29.7492 14.7311 29.6686 14.7307Z"
      fill="currentColor"
    />

    <path
      d="M29.7152 14.3317C30.9778 14.3317 32.0014 13.2987 32.0014 12.0244C32.0014 10.7502 30.9778 9.71716 29.7152 9.71716C28.4525 9.71716 27.429 10.7502 27.429 12.0244C27.429 13.2987 28.4525 14.3317 29.7152 14.3317Z"
      fill="currentColor"
    />

    <path
      d="M22.8565 12.4249C22.7759 12.4249 22.6985 12.4572 22.6413 12.5146C22.5842 12.572 22.5519 12.6499 22.5515 12.7313V25.4976C22.5515 25.5792 22.5836 25.6575 22.6409 25.7152C22.6981 25.7729 22.7756 25.8054 22.8565 25.8054C22.9374 25.8054 23.015 25.7729 23.0722 25.7152C23.1294 25.6575 23.1616 25.5792 23.1616 25.4976V12.7313C23.1616 12.691 23.1537 12.651 23.1383 12.6137C23.123 12.5765 23.1005 12.5426 23.0721 12.5142C23.0438 12.4857 23.0101 12.4632 22.9732 12.4478C22.9362 12.4325 22.8965 12.4247 22.8565 12.4249Z"
      fill="currentColor"
    />

    <path
      d="M22.8565 12.0244C24.1192 12.0244 25.1428 10.9914 25.1428 9.71718C25.1428 8.44291 24.1192 7.40991 22.8565 7.40991C21.5939 7.40991 20.5703 8.44291 20.5703 9.71718C20.5703 10.9914 21.5939 12.0244 22.8565 12.0244Z"
      fill="currentColor"
    />

    <path
      d="M16.0035 10.0065C15.9235 10.0073 15.847 10.0399 15.7907 10.0972C15.7343 10.1546 15.7027 10.2321 15.7027 10.3129V27.6994C15.6999 27.7414 15.7056 27.7837 15.7197 27.8234C15.7337 27.8632 15.7556 27.8996 15.7842 27.9304C15.8127 27.9612 15.8472 27.9858 15.8855 28.0026C15.9239 28.0194 15.9652 28.0281 16.007 28.0281C16.0488 28.0281 16.0902 28.0194 16.1285 28.0026C16.1669 27.9858 16.2014 27.9612 16.2299 27.9304C16.2585 27.8996 16.2804 27.8632 16.2944 27.8234C16.3084 27.7837 16.3142 27.7414 16.3114 27.6994V10.3129C16.3114 10.2723 16.3034 10.2321 16.2878 10.1947C16.2723 10.1572 16.2496 10.1232 16.2209 10.0947C16.1923 10.0662 16.1583 10.0437 16.121 10.0286C16.0837 10.0134 16.0437 10.0059 16.0035 10.0065Z"
      fill="currentColor"
    />

    <path
      d="M15.9993 9.61454C17.2619 9.61454 18.2855 8.58154 18.2855 7.30727C18.2855 6.033 17.2619 5 15.9993 5C14.7366 5 13.7131 6.033 13.7131 7.30727C13.7131 8.58154 14.7366 9.61454 15.9993 9.61454Z"
      fill="currentColor"
    />

    <path
      d="M9.14208 12.4207C9.06143 12.421 8.98421 12.4536 8.92731 12.5113C8.87042 12.569 8.83847 12.6471 8.83847 12.7285V25.4933C8.83563 25.5354 8.84139 25.5776 8.8554 25.6173C8.8694 25.6571 8.89136 25.6935 8.91989 25.7243C8.94843 25.7552 8.98294 25.7798 9.02128 25.7966C9.05963 25.8134 9.10098 25.822 9.14279 25.822C9.18459 25.822 9.22595 25.8134 9.26429 25.7966C9.30263 25.7798 9.33714 25.7552 9.36568 25.7243C9.39422 25.6935 9.41617 25.6571 9.43018 25.6173C9.44418 25.5776 9.44994 25.5354 9.4471 25.4933V12.7285C9.4471 12.6468 9.41496 12.5685 9.35776 12.5108C9.30056 12.4531 9.22298 12.4207 9.14208 12.4207Z"
      fill="currentColor"
    />

    <path
      d="M9.14205 12.0244C10.4047 12.0244 11.4283 10.9914 11.4283 9.71718C11.4283 8.44291 10.4047 7.40991 9.14205 7.40991C7.87941 7.40991 6.85583 8.44291 6.85583 9.71718C6.85583 10.9914 7.87941 12.0244 9.14205 12.0244Z"
      fill="currentColor"
    />

    <path
      d="M2.30032 14.7279C2.21942 14.7279 2.14184 14.7603 2.08464 14.8181C2.02744 14.8758 1.9953 14.9541 1.9953 15.0357V23.186C1.9953 23.2676 2.02744 23.3459 2.08464 23.4037C2.14184 23.4614 2.21942 23.4938 2.30032 23.4938C2.38121 23.4938 2.4588 23.4614 2.516 23.4037C2.5732 23.3459 2.60534 23.2676 2.60534 23.186V15.0357C2.60534 14.9953 2.59745 14.9553 2.58212 14.9179C2.56679 14.8806 2.54432 14.8467 2.516 14.8181C2.48767 14.7895 2.45405 14.7668 2.41704 14.7513C2.38004 14.7359 2.34037 14.7279 2.30032 14.7279Z"
      fill="currentColor"
    />

    <path
      d="M2.28622 14.3317C3.54886 14.3317 4.57244 13.2987 4.57244 12.0244C4.57244 10.7502 3.54886 9.71716 2.28622 9.71716C1.02358 9.71716 0 10.7502 0 12.0244C0 13.2987 1.02358 14.3317 2.28622 14.3317Z"
      fill="currentColor"
    />
  </SvgIcon>
);
